// Firebase Configuration for Tabletop Inventory Manager
// Web Firebase config values are public identifiers (not secrets); access is
// enforced by Firebase security rules server-side, not by hiding these values.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
// [S6]: Firebase Analytics — free, automatic with Firebase SDK.
// Requires measurementId in firebaseConfig (enable Analytics in Firebase Console).
import { getAnalytics, logEvent, setUserProperties, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyCQ9ewjztOdgg79sb9L8iC_e2mpEzPdpmI",
  authDomain: "tabletopinventory-b83b8.firebaseapp.com",
  databaseURL: "https://tabletopinventory-b83b8-default-rtdb.firebaseio.com",
  projectId: "tabletopinventory-b83b8",
  storageBucket: "tabletopinventory-b83b8.firebasestorage.app",
  messagingSenderId: "335621380979",
  appId: "1:335621380979:web:6423f85cdf729cafa38306"
  // [S6 USER ACTION]: Add measurementId here after enabling Analytics in Firebase Console.
  // Firebase Console → Project Settings → Your apps → Web app → measurementId
  // Example: measurementId: "G-XXXXXXXXXX"
};

// Initialize Firebase
let app;
let auth;
let database;
let analytics = null;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  database = getDatabase(app);

  // [S6]: Initialize Analytics only if the browser supports it AND config has measurementId.
  // isSupported() checks for cookie/storage availability (fails in some WebViews).
  // Without measurementId, getAnalytics() throws — the guard prevents that.
  if (firebaseConfig.measurementId) {
    isSupported().then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    }).catch(() => {
      // [PURPOSE]: Analytics not supported in this environment (e.g., some Capacitor WebViews).
      // Non-fatal — app works fine without analytics.
    });
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { auth, database, analytics, logEvent, setUserProperties };
export default app;